<script setup lang="ts">
const { panelWaterfallId } = useGlobals()
const { isSelected } = useSelection()
const { computedSortedFilesInCollection } = useCollectionView()
const { state: panelState } = usePanel()

const tileWidth = computed(() => Math.max(0, (panelState.value.width - 10) / 5))
// TODO: scale the thumbnail based on the size of the view
// TODO: make the waterfall more configurable?
</script>

<template>
  <div :id="panelWaterfallId" class="waterfall">
    <div
      v-for="file in computedSortedFilesInCollection"
      :key="file.fileId"
      class="aspect-square w-full cursor-pointer"
      :data-file-id="file.fileId"
    >
      <div class="waterfall-tile">
        <file-thumbnail
          :file
          :selected="isSelected(file.fileId)"
          :container-height="tileWidth"
          :container-width="tileWidth"
          cropped
          shadowed
          flat
        />
      </div>
    </div>
  </div>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.waterfall
  @apply grid grid-cols-5 flex-none gap-0.5 grid-content-start overflow-auto pl-0.25 h-full p-0.5

.waterfall-tile
  @apply aspect-square
</style>
